import Layout from "./Layout";
import { useState, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";

const AffiliateLink = () => {
  const navigate = useNavigate();
  const preventMaxInput = (e) => {
    e.target.value = e.target.value.trimStart();
    e.target.value = e.target.value.replace(/  +/g, " ");
  };
  const { t } = useTranslation();
  const { search } = useLocation();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    trigger,
    control,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const handleShow = () => {
    setShowPassword(!showPassword);
  };
  const handleShow2 = () => {
    setShowPassword2(!showPassword2);
  };
  useEffect(() => {
    if (!isEmpty(watch("confirmPassword"))) {
      if (watch("password")) {
        trigger("confirmPassword");
      }
    }
  }, [watch("password")]);

  const onSubmit = async (body) => {
    let hostname = window.location.hostname;
    hostname = hostname.replace(/^www\./, "");
    hostname = hostname.replace(/^ag\./, "");
    const { status, data } = await apiPost(apiPath.affiliate, {
      whatsappNumber: body?.mobile,
      username: body?.username,
      password: body?.password,
      confirmPassword: body?.confirmPassword,
      referral_code: body?.referral_code || "",
      website: hostname || "SABAEXCH",
    });
    if (status === 200) {
      if (data.success) {
        toast.success(data?.message);
        navigate(
          `/affilates?referral_code=${data?.results?.adminuser?.referalCode}`
        );
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
  };

  useEffect(() => {
    if (!isEmpty(search)) {
      if (search?.split("=")[0] == "?referral_code") {
        setValue("referral_code", search?.split("=")[1]);
      }
    }
  }, [search]);

  return (
    <Layout>
      <div className="full-width">
        <div
          className={`col col-12 ${isMobile ? "px-2" : "px-5"}  register_panel`}
        >
          <div className="row hidden-md-and-up">
            <div className="mobile-header text-center col col-12">
              Affiliate
            </div>
          </div>
          <div
            className="row hidden-sm-and-down mt-2"
            style={{ margin: "unset" }}
          ></div>

          <div
            className={`row justify-center ${
              isMobile ? "hidden-md-and-up" : "mt-2 hidden-sm-and-down mb-4"
            } `}
          >
            <div className="col col-12">
              <div className="v-window v-item-group theme--light ma-8">
                <div className="v-window__container">
                  <div className="v-window-item v-window-item--active">
                    <Form onSubmit={handleSubmit(onSubmit)} className="v-form">
                      <div className="row justify-center">
                        <div className="col-md-8 col-12">
                          <div className="v-card__text ma-0 pa-0">
                            {/* Username Field */}
                            <div className={isMobile ? "mobile" : ""}>
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label
                                    className="input-field-label ma-0 text-capitalize d-block pb-1"
                                    style={{ float: "left" }}
                                  >
                                    {t("Username")}
                                    <span className="red--text ml-1">*</span>
                                  </label>
                                </div>

                                <div className="col col-12">
                                  <div
                                    className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${
                                      !isEmpty(errors.username)
                                        ? "error--text v-input--has-state"
                                        : ""
                                    } `}
                                  >
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{ width: "0px" }}>
                                            <span className="notranslate">
                                              ​
                                            </span>
                                          </legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                            autoComplete="new-password"
                                            id="input-5797"
                                            placeholder={t("FillUpHere")}
                                            type="text"
                                            {...register("username", {
                                              required: t("Enter_Username"),
                                              minLength: {
                                                value: 3,
                                                message: t("Min3User"),
                                              },
                                              maxLength: {
                                                value: 30,
                                                message: t("Max30User"),
                                              },
                                              pattern: {
                                                value: /^[a-zA-Z0-9]*$/,
                                                message: t(
                                                  "Enter_Valid_Username",
                                                ),
                                              },
                                            })}
                                          />
                                        </div>
                                      </div>
                                      {errors.username &&
                                        errors.username.message && (
                                          <div className="v-text-field__details">
                                            <div
                                              className="v-messages theme--light error--text"
                                              role="alert"
                                            >
                                              <div className="v-messages__wrapper">
                                                <div className="v-messages__message">
                                                  {errors.username.message}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Password Field */}
                            <div className={isMobile ? "mobile" : ""}>
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label
                                    className="input-field-label ma-0 text-capitalize d-block pb-1"
                                    style={{ float: "left" }}
                                  >
                                    {t("Password")}
                                    <span className="red--text ml-1">*</span>
                                  </label>
                                </div>

                                <div className="col col-12">
                                  <div
                                    className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${
                                      !isEmpty(errors.password)
                                        ? "error--text v-input--has-state"
                                        : ""
                                    } `}
                                  >
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{ width: "0px" }}>
                                            <span className="notranslate">
                                              ​
                                            </span>
                                          </legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                            autoComplete="new-password"
                                            id="input-5803"
                                            type={
                                              !showPassword
                                                ? "text"
                                                : "password"
                                            }
                                            placeholder={t("Password")}
                                            {...register("password", {
                                              required: t("Enter_Password"),
                                              minLength: {
                                                value: 6,
                                                message: t("PasswordMin"),
                                              },
                                              maxLength: {
                                                value: 20,
                                                message: t("PasswordMax"),
                                              },
                                            })}
                                          />
                                        </div>
                                        <div
                                          onClick={() => handleShow()}
                                          className="v-input__append-inner"
                                        >
                                          <button
                                            type="button"
                                            className={`v-icon notranslate v-icon--link mdi ${
                                              showPassword
                                                ? "mdi-eye"
                                                : "mdi-eye-off"
                                            } theme--light`}
                                          />
                                        </div>
                                      </div>
                                      {errors.password &&
                                        errors.password.message && (
                                          <div className="v-text-field__details">
                                            <div
                                              className="v-messages theme--light error--text"
                                              role="alert"
                                            >
                                              <div className="v-messages__wrapper">
                                                <div className="v-messages__message">
                                                  {errors.password.message}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Confirm Password Field */}
                            <div className={isMobile ? "mobile" : ""}>
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label
                                    className="input-field-label ma-0 text-capitalize d-block pb-1"
                                    style={{ float: "left" }}
                                  >
                                    {t("Confirm_Password")}
                                    <span className="red--text ml-1">*</span>
                                  </label>
                                </div>
                                <div className="col col-2"></div>
                                <div className="col col-12">
                                  <div
                                    className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${
                                      !isEmpty(errors.confirmPassword)
                                        ? "error--text v-input--has-state"
                                        : ""
                                    } `}
                                  >
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{ width: "0px" }}>
                                            <span className="notranslate">
                                              ​
                                            </span>
                                          </legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                            autoComplete="new-password"
                                            id="input-5808"
                                            type={
                                              !showPassword2
                                                ? "text"
                                                : "password"
                                            }
                                            placeholder={t("Confirm_Password")}
                                            {...register("confirmPassword", {
                                              required: t("Enter_CPassword"),
                                              validate: (value) => {
                                                if (
                                                  !isEmpty(watch("password"))
                                                ) {
                                                  if (
                                                    value == watch("password")
                                                  ) {
                                                    return true;
                                                  } else {
                                                    return t("PasswordMatch");
                                                  }
                                                }
                                              },
                                            })}
                                          />
                                        </div>
                                        <div
                                          onClick={() => handleShow2()}
                                          className="v-input__append-inner"
                                        >
                                          <button
                                            type="button"
                                            className={`v-icon notranslate v-icon--link mdi ${
                                              showPassword2
                                                ? "mdi-eye"
                                                : "mdi-eye-off"
                                            } theme--light`}
                                          />
                                        </div>
                                      </div>
                                      {errors.confirmPassword &&
                                        errors.confirmPassword.message && (
                                          <div className="v-text-field__details">
                                            <div
                                              className="v-messages theme--light error--text"
                                              role="alert"
                                            >
                                              <div className="v-messages__wrapper">
                                                <div className="v-messages__message">
                                                  {
                                                    errors.confirmPassword
                                                      .message
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Mobile Number Field */}
                            <div className={isMobile ? "mobile" : ""}>
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label
                                    className="input-field-label ma-0 text-capitalize d-block pb-1"
                                    style={{ float: "left" }}
                                  >
                                    {t("PhoneNumber")}
                                    <span className="red--text ml-1">*</span>
                                  </label>
                                </div>
                                <div className="col col-12">
                                  <div
                                    className={`v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder ${
                                      !isEmpty(errors.mobile)
                                        ? "error--text v-input--has-state"
                                        : ""
                                    } `}
                                  >
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{ width: "0px" }}>
                                            <span className="notranslate">
                                              ​
                                            </span>
                                          </legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                            autoComplete="new-password"
                                            id="input-5835"
                                            placeholder={t("FillUpHere")}
                                            type="number"
                                            {...register("mobile", {
                                              required: t("Entervalidnumber"),
                                              minLength: {
                                                value: 10,
                                                message: t("MobileMin"),
                                              },
                                              maxLength: {
                                                value: 12,
                                                message: t("MobileMax"),
                                              },
                                            })}
                                          />
                                        </div>
                                      </div>
                                      {errors.mobile &&
                                        errors.mobile.message && (
                                          <div className="v-text-field__details">
                                            <div
                                              className="v-messages theme--light error--text"
                                              role="alert"
                                            >
                                              <div className="v-messages__wrapper">
                                                <div className="v-messages__message">
                                                  {errors.mobile.message}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Referral Code Field */}
                            <div className={isMobile ? "mobile" : ""}>
                              <div className="row no-gutters justify-space-between">
                                <div className="col col-10">
                                  <label
                                    className="input-field-label ma-0 text-capitalize d-block pb-1"
                                    style={{ float: "left" }}
                                  >
                                    {t("ReferralCode")}
                                  </label>
                                </div>
                                <div className="col col-2"></div>
                                <div className="col col-12">
                                  <div className="v-input input-field elevation-0 hide-details theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder">
                                    <div className="v-input__control">
                                      <div className="v-input__slot">
                                        <fieldset aria-hidden="true">
                                          <legend style={{ width: "0px" }}>
                                            <span className="notranslate">
                                              ​
                                            </span>
                                          </legend>
                                        </fieldset>
                                        <div className="v-text-field__slot">
                                          <input
                                            autoComplete="new-password"
                                            id="input-5839"
                                            placeholder={t("Optional")}
                                            type="text"
                                            {...register("referral_code")}
                                          />
                                        </div>
                                      </div>
                                      <div className="v-text-field__details">
                                        <div className="v-messages theme--light">
                                          <div className="v-messages__wrapper" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Submit Button */}
                            <div className="row no-gutters">
                              <div className="col col-12">
                                <button
                                  data-v-1dea3caa
                                  type="submit"
                                  className="full-width font-weight-bold pa-2 dialog-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default buttonPrimary theme-button theme--light subtitle-1 mobile-next-btn"
                                >
                                  <span className="v-btn__content">Submit</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AffiliateLink;
